import axios from 'axios';
import secureStorage from 'utils/secureStorage';

const base_url = process.env.NODE_ENV === 'development' 
  ? "http://localhost:8000" 
  : "https://syspax-api.ldspartners.com.br";

// Timeout padrão finito: antes era 9999999 ms (~2,7h) e, no incidente de
// 28/09/2026 (precatorios_web#9), requisições penduradas viravam carregamento
// infinito sem nenhuma mensagem. Exports e uploads passam timeout próprio.
export const REQUEST_TIMEOUT_MS = 30000;
export const UPLOAD_TIMEOUT_MS = 180000;

export const api = axios.create({
  baseURL: base_url,
  timeout: REQUEST_TIMEOUT_MS,
});

export const api_download = (url) => {
  return `${base_url}/${url}`;
};

const notifyUnauthorized = () => {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent("app:unauthorized"));
  }
};

api.interceptors.request.use(
  (config) => {
    const token = secureStorage.getToken();

    if (token && !config.headers.Authorization) {
      config.headers.Authorization = `Token ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error),
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;

    if (status === 401) {
      secureStorage.removeToken();
      notifyUnauthorized();
    }

    return Promise.reject(error);
  },
);
